import { useMount } from 'ahooks';
import { Suspense } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { getDefaultLandingPath } from 'src/hook/usePermission';
import { ROUTE_PATH } from 'src/routes/route.constant';
import { getAccessToken, getRoleAccount } from 'src/store/auth/useAuthStore';
import { useNationalAggregation } from 'src/store/nationalAggregation/useNationalAggregation';
import { useProfileStore } from 'src/store/profile/useProfileStore';

const AppLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { requestGetProfile } = useProfileStore();
  useNationalAggregation();

  useMount(() => {
    requestGetProfile();
  });

  /* [DEPRECATED 2026-06-30] - Hard-coded redirect to /question-management caused 404 for
   * TEACHER / FORM_TEACHER / SCHOOL_MANAGER (path is in their IGNORE_ROLE_* blocklist).
   *
   *   useMount(() => {
   *     const isLogin = getAccessToken();
   *     if (!isLogin) return navigate(ROUTE_PATH.LOGIN);
   *     if (location.pathname === '/') navigate(ROUTE_PATH.QUESTION_MANAGEMENT);
   *   });
   */

  // [NEW 2026-06-30] - Role-aware redirect: unauth → /login, root → role-based landing path.
  useMount(() => {
    const isLogin = getAccessToken();

    if (!isLogin) return navigate(ROUTE_PATH.LOGIN);

    if (location.pathname === '/') navigate(getDefaultLandingPath(getRoleAccount()));
  });

  return (
    <Suspense fallback={null}>
      <Outlet />
    </Suspense>
  );
};

export default AppLayout;
